import React, {Component} from "react";
import {NAN_PARAMS, PARAMS_NAME} from "../../../BidderNetworkPerformanceHourlyV2/config";
import Table from "../../../../components/StatsTable";

class ContentForYouTable extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { params, report, total } = this.props.report;

        const paramsObj = params.reduce((obj, param, index) => {
            obj[param] = index;

            return obj;
        }, {});

        return (
            <div>
                <Table params={params} paramsObj={paramsObj} report={report} total={total} paramNames={{...PARAMS_NAME, clicks: "Clicks", counter: "Counter" }} NaNParams={{ ...NAN_PARAMS, source: 1 }}/>
            </div>
        )
    }
}

export default ContentForYouTable;



// WEBPACK FOOTER //
// ./src/scenes/ContentForYouDaily/components/ContentForYouTable/index.js